// packages/alpinejs/src/scheduler.js
var $906f7c99ef13dbef$var$flushPending = false;
var $906f7c99ef13dbef$var$flushing = false;
var $906f7c99ef13dbef$var$queue = [];
var $906f7c99ef13dbef$var$lastFlushedIndex = -1;
function $906f7c99ef13dbef$var$scheduler(callback) {
    $906f7c99ef13dbef$var$queueJob(callback);
}
function $906f7c99ef13dbef$var$queueJob(job) {
    if (!$906f7c99ef13dbef$var$queue.includes(job)) $906f7c99ef13dbef$var$queue.push(job);
    $906f7c99ef13dbef$var$queueFlush();
}
function $906f7c99ef13dbef$var$dequeueJob(job) {
    let index = $906f7c99ef13dbef$var$queue.indexOf(job);
    if (index !== -1 && index > $906f7c99ef13dbef$var$lastFlushedIndex) $906f7c99ef13dbef$var$queue.splice(index, 1);
}
function $906f7c99ef13dbef$var$queueFlush() {
    if (!$906f7c99ef13dbef$var$flushing && !$906f7c99ef13dbef$var$flushPending) {
        $906f7c99ef13dbef$var$flushPending = true;
        queueMicrotask($906f7c99ef13dbef$var$flushJobs);
    }
}
function $906f7c99ef13dbef$var$flushJobs() {
    $906f7c99ef13dbef$var$flushPending = false;
    $906f7c99ef13dbef$var$flushing = true;
    for(let i = 0; i < $906f7c99ef13dbef$var$queue.length; i++){
        $906f7c99ef13dbef$var$queue[i]();
        $906f7c99ef13dbef$var$lastFlushedIndex = i;
    }
    $906f7c99ef13dbef$var$queue.length = 0;
    $906f7c99ef13dbef$var$lastFlushedIndex = -1;
    $906f7c99ef13dbef$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $906f7c99ef13dbef$var$reactive;
var $906f7c99ef13dbef$var$effect;
var $906f7c99ef13dbef$var$release;
var $906f7c99ef13dbef$var$raw;
var $906f7c99ef13dbef$var$shouldSchedule = true;
function $906f7c99ef13dbef$var$disableEffectScheduling(callback) {
    $906f7c99ef13dbef$var$shouldSchedule = false;
    callback();
    $906f7c99ef13dbef$var$shouldSchedule = true;
}
function $906f7c99ef13dbef$var$setReactivityEngine(engine) {
    $906f7c99ef13dbef$var$reactive = engine.reactive;
    $906f7c99ef13dbef$var$release = engine.release;
    $906f7c99ef13dbef$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($906f7c99ef13dbef$var$shouldSchedule) $906f7c99ef13dbef$var$scheduler(task);
                else task();
            }
        });
    $906f7c99ef13dbef$var$raw = engine.raw;
}
function $906f7c99ef13dbef$var$overrideEffect(override) {
    $906f7c99ef13dbef$var$effect = override;
}
function $906f7c99ef13dbef$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $906f7c99ef13dbef$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $906f7c99ef13dbef$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $906f7c99ef13dbef$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $906f7c99ef13dbef$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$906f7c99ef13dbef$var$release(effectReference);
}
// packages/alpinejs/src/utils/dispatch.js
function $906f7c99ef13dbef$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $906f7c99ef13dbef$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$906f7c99ef13dbef$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $906f7c99ef13dbef$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $906f7c99ef13dbef$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $906f7c99ef13dbef$var$started = false;
function $906f7c99ef13dbef$var$start() {
    if ($906f7c99ef13dbef$var$started) $906f7c99ef13dbef$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $906f7c99ef13dbef$var$started = true;
    if (!document.body) $906f7c99ef13dbef$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $906f7c99ef13dbef$var$dispatch(document, "alpine:init");
    $906f7c99ef13dbef$var$dispatch(document, "alpine:initializing");
    $906f7c99ef13dbef$var$startObservingMutations();
    $906f7c99ef13dbef$var$onElAdded((el)=>$906f7c99ef13dbef$var$initTree(el, $906f7c99ef13dbef$var$walk));
    $906f7c99ef13dbef$var$onElRemoved((el)=>$906f7c99ef13dbef$var$destroyTree(el));
    $906f7c99ef13dbef$var$onAttributesAdded((el, attrs)=>{
        $906f7c99ef13dbef$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$906f7c99ef13dbef$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($906f7c99ef13dbef$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $906f7c99ef13dbef$var$initTree(el);
    });
    $906f7c99ef13dbef$var$dispatch(document, "alpine:initialized");
}
var $906f7c99ef13dbef$var$rootSelectorCallbacks = [];
var $906f7c99ef13dbef$var$initSelectorCallbacks = [];
function $906f7c99ef13dbef$var$rootSelectors() {
    return $906f7c99ef13dbef$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $906f7c99ef13dbef$var$allSelectors() {
    return $906f7c99ef13dbef$var$rootSelectorCallbacks.concat($906f7c99ef13dbef$var$initSelectorCallbacks).map((fn)=>fn());
}
function $906f7c99ef13dbef$var$addRootSelector(selectorCallback) {
    $906f7c99ef13dbef$var$rootSelectorCallbacks.push(selectorCallback);
}
function $906f7c99ef13dbef$var$addInitSelector(selectorCallback) {
    $906f7c99ef13dbef$var$initSelectorCallbacks.push(selectorCallback);
}
function $906f7c99ef13dbef$var$closestRoot(el, includeInitSelectors = false) {
    return $906f7c99ef13dbef$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $906f7c99ef13dbef$var$allSelectors() : $906f7c99ef13dbef$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $906f7c99ef13dbef$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $906f7c99ef13dbef$var$findClosest(el.parentElement, callback);
}
function $906f7c99ef13dbef$var$isRoot(el) {
    return $906f7c99ef13dbef$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $906f7c99ef13dbef$var$initInterceptors = [];
function $906f7c99ef13dbef$var$interceptInit(callback) {
    $906f7c99ef13dbef$var$initInterceptors.push(callback);
}
function $906f7c99ef13dbef$var$initTree(el, walker = $906f7c99ef13dbef$var$walk, intercept = ()=>{}) {
    $906f7c99ef13dbef$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $906f7c99ef13dbef$var$initInterceptors.forEach((i)=>i(el2, skip));
            $906f7c99ef13dbef$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $906f7c99ef13dbef$var$destroyTree(root, walker = $906f7c99ef13dbef$var$walk) {
    walker(root, (el)=>{
        $906f7c99ef13dbef$var$cleanupAttributes(el);
        $906f7c99ef13dbef$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $906f7c99ef13dbef$var$onAttributeAddeds = [];
var $906f7c99ef13dbef$var$onElRemoveds = [];
var $906f7c99ef13dbef$var$onElAddeds = [];
function $906f7c99ef13dbef$var$onElAdded(callback) {
    $906f7c99ef13dbef$var$onElAddeds.push(callback);
}
function $906f7c99ef13dbef$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $906f7c99ef13dbef$var$onElRemoveds.push(callback);
    }
}
function $906f7c99ef13dbef$var$onAttributesAdded(callback) {
    $906f7c99ef13dbef$var$onAttributeAddeds.push(callback);
}
function $906f7c99ef13dbef$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $906f7c99ef13dbef$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $906f7c99ef13dbef$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $906f7c99ef13dbef$var$observer = new MutationObserver($906f7c99ef13dbef$var$onMutate);
var $906f7c99ef13dbef$var$currentlyObserving = false;
function $906f7c99ef13dbef$var$startObservingMutations() {
    $906f7c99ef13dbef$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $906f7c99ef13dbef$var$currentlyObserving = true;
}
function $906f7c99ef13dbef$var$stopObservingMutations() {
    $906f7c99ef13dbef$var$flushObserver();
    $906f7c99ef13dbef$var$observer.disconnect();
    $906f7c99ef13dbef$var$currentlyObserving = false;
}
var $906f7c99ef13dbef$var$queuedMutations = [];
function $906f7c99ef13dbef$var$flushObserver() {
    let records = $906f7c99ef13dbef$var$observer.takeRecords();
    $906f7c99ef13dbef$var$queuedMutations.push(()=>records.length > 0 && $906f7c99ef13dbef$var$onMutate(records));
    let queueLengthWhenTriggered = $906f7c99ef13dbef$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($906f7c99ef13dbef$var$queuedMutations.length === queueLengthWhenTriggered) while($906f7c99ef13dbef$var$queuedMutations.length > 0)$906f7c99ef13dbef$var$queuedMutations.shift()();
    });
}
function $906f7c99ef13dbef$var$mutateDom(callback) {
    if (!$906f7c99ef13dbef$var$currentlyObserving) return callback();
    $906f7c99ef13dbef$var$stopObservingMutations();
    let result = callback();
    $906f7c99ef13dbef$var$startObservingMutations();
    return result;
}
var $906f7c99ef13dbef$var$isCollecting = false;
var $906f7c99ef13dbef$var$deferredMutations = [];
function $906f7c99ef13dbef$var$deferMutations() {
    $906f7c99ef13dbef$var$isCollecting = true;
}
function $906f7c99ef13dbef$var$flushAndStopDeferringMutations() {
    $906f7c99ef13dbef$var$isCollecting = false;
    $906f7c99ef13dbef$var$onMutate($906f7c99ef13dbef$var$deferredMutations);
    $906f7c99ef13dbef$var$deferredMutations = [];
}
function $906f7c99ef13dbef$var$onMutate(mutations) {
    if ($906f7c99ef13dbef$var$isCollecting) {
        $906f7c99ef13dbef$var$deferredMutations = $906f7c99ef13dbef$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $906f7c99ef13dbef$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $906f7c99ef13dbef$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $906f7c99ef13dbef$var$onElRemoveds.forEach((i)=>i(node));
        $906f7c99ef13dbef$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $906f7c99ef13dbef$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $906f7c99ef13dbef$var$scope(node) {
    return $906f7c99ef13dbef$var$mergeProxies($906f7c99ef13dbef$var$closestDataStack(node));
}
function $906f7c99ef13dbef$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$906f7c99ef13dbef$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $906f7c99ef13dbef$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $906f7c99ef13dbef$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $906f7c99ef13dbef$var$closestDataStack(node.parentNode);
}
function $906f7c99ef13dbef$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $906f7c99ef13dbef$var$mergeProxyTrap);
}
var $906f7c99ef13dbef$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $906f7c99ef13dbef$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $906f7c99ef13dbef$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $906f7c99ef13dbef$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $906f7c99ef13dbef$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$906f7c99ef13dbef$var$get(data2, path), (value)=>$906f7c99ef13dbef$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $906f7c99ef13dbef$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $906f7c99ef13dbef$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $906f7c99ef13dbef$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $906f7c99ef13dbef$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $906f7c99ef13dbef$var$magics = {};
function $906f7c99ef13dbef$var$magic(name, callback) {
    $906f7c99ef13dbef$var$magics[name] = callback;
}
function $906f7c99ef13dbef$var$injectMagics(obj, el) {
    Object.entries($906f7c99ef13dbef$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $906f7c99ef13dbef$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $906f7c99ef13dbef$var$interceptor,
                    ...utilities
                };
                $906f7c99ef13dbef$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $906f7c99ef13dbef$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $906f7c99ef13dbef$var$handleError(e, el, expression);
    }
}
function $906f7c99ef13dbef$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $906f7c99ef13dbef$var$shouldAutoEvaluateFunctions = true;
function $906f7c99ef13dbef$var$dontAutoEvaluateFunctions(callback) {
    let cache = $906f7c99ef13dbef$var$shouldAutoEvaluateFunctions;
    $906f7c99ef13dbef$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $906f7c99ef13dbef$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $906f7c99ef13dbef$var$evaluate(el, expression, extras = {}) {
    let result;
    $906f7c99ef13dbef$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $906f7c99ef13dbef$var$evaluateLater(...args) {
    return $906f7c99ef13dbef$var$theEvaluatorFunction(...args);
}
var $906f7c99ef13dbef$var$theEvaluatorFunction = $906f7c99ef13dbef$var$normalEvaluator;
function $906f7c99ef13dbef$var$setEvaluator(newEvaluator) {
    $906f7c99ef13dbef$var$theEvaluatorFunction = newEvaluator;
}
function $906f7c99ef13dbef$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $906f7c99ef13dbef$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$906f7c99ef13dbef$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $906f7c99ef13dbef$var$generateEvaluatorFromFunction(dataStack, expression) : $906f7c99ef13dbef$var$generateEvaluatorFromString(dataStack, expression, el);
    return $906f7c99ef13dbef$var$tryCatch.bind(null, el, expression, evaluator);
}
function $906f7c99ef13dbef$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($906f7c99ef13dbef$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $906f7c99ef13dbef$var$runIfTypeOfFunction(receiver, result);
    };
}
var $906f7c99ef13dbef$var$evaluatorMemo = {};
function $906f7c99ef13dbef$var$generateFunctionFromString(expression, el) {
    if ($906f7c99ef13dbef$var$evaluatorMemo[expression]) return $906f7c99ef13dbef$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $906f7c99ef13dbef$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $906f7c99ef13dbef$var$evaluatorMemo[expression] = func;
    return func;
}
function $906f7c99ef13dbef$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $906f7c99ef13dbef$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $906f7c99ef13dbef$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$906f7c99ef13dbef$var$handleError(error2, el, expression));
            if (func.finished) {
                $906f7c99ef13dbef$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $906f7c99ef13dbef$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$906f7c99ef13dbef$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $906f7c99ef13dbef$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($906f7c99ef13dbef$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$906f7c99ef13dbef$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$906f7c99ef13dbef$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $906f7c99ef13dbef$var$prefixAsString = "x-";
function $906f7c99ef13dbef$var$prefix(subject = "") {
    return $906f7c99ef13dbef$var$prefixAsString + subject;
}
function $906f7c99ef13dbef$var$setPrefix(newPrefix) {
    $906f7c99ef13dbef$var$prefixAsString = newPrefix;
}
var $906f7c99ef13dbef$var$directiveHandlers = {};
function $906f7c99ef13dbef$var$directive(name, callback) {
    $906f7c99ef13dbef$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$906f7c99ef13dbef$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $906f7c99ef13dbef$var$directiveOrder.indexOf(directive2);
            $906f7c99ef13dbef$var$directiveOrder.splice(pos >= 0 ? pos : $906f7c99ef13dbef$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $906f7c99ef13dbef$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $906f7c99ef13dbef$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($906f7c99ef13dbef$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($906f7c99ef13dbef$var$outNonAlpineAttributes).map($906f7c99ef13dbef$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($906f7c99ef13dbef$var$byPriority);
    return directives2.map((directive2)=>{
        return $906f7c99ef13dbef$var$getDirectiveHandler(el, directive2);
    });
}
function $906f7c99ef13dbef$var$attributesOnly(attributes) {
    return Array.from(attributes).map($906f7c99ef13dbef$var$toTransformedAttributes()).filter((attr)=>!$906f7c99ef13dbef$var$outNonAlpineAttributes(attr));
}
var $906f7c99ef13dbef$var$isDeferringHandlers = false;
var $906f7c99ef13dbef$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $906f7c99ef13dbef$var$currentHandlerStackKey = Symbol();
function $906f7c99ef13dbef$var$deferHandlingDirectives(callback) {
    $906f7c99ef13dbef$var$isDeferringHandlers = true;
    let key = Symbol();
    $906f7c99ef13dbef$var$currentHandlerStackKey = key;
    $906f7c99ef13dbef$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($906f7c99ef13dbef$var$directiveHandlerStacks.get(key).length)$906f7c99ef13dbef$var$directiveHandlerStacks.get(key).shift()();
        $906f7c99ef13dbef$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $906f7c99ef13dbef$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $906f7c99ef13dbef$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $906f7c99ef13dbef$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $906f7c99ef13dbef$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $906f7c99ef13dbef$var$evaluateLater.bind($906f7c99ef13dbef$var$evaluateLater, el),
        evaluate: $906f7c99ef13dbef$var$evaluate.bind($906f7c99ef13dbef$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $906f7c99ef13dbef$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $906f7c99ef13dbef$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $906f7c99ef13dbef$var$getElementBoundUtilities(el);
    $906f7c99ef13dbef$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $906f7c99ef13dbef$var$isDeferringHandlers ? $906f7c99ef13dbef$var$directiveHandlerStacks.get($906f7c99ef13dbef$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $906f7c99ef13dbef$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $906f7c99ef13dbef$var$into = (i)=>i;
function $906f7c99ef13dbef$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $906f7c99ef13dbef$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $906f7c99ef13dbef$var$attributeTransformers = [];
function $906f7c99ef13dbef$var$mapAttributes(callback) {
    $906f7c99ef13dbef$var$attributeTransformers.push(callback);
}
function $906f7c99ef13dbef$var$outNonAlpineAttributes({ name: name }) {
    return $906f7c99ef13dbef$var$alpineAttributeRegex().test(name);
}
var $906f7c99ef13dbef$var$alpineAttributeRegex = ()=>new RegExp(`^${$906f7c99ef13dbef$var$prefixAsString}([^:^.]+)\\b`);
function $906f7c99ef13dbef$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($906f7c99ef13dbef$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $906f7c99ef13dbef$var$DEFAULT = "DEFAULT";
var $906f7c99ef13dbef$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $906f7c99ef13dbef$var$DEFAULT,
    "teleport"
];
function $906f7c99ef13dbef$var$byPriority(a, b) {
    let typeA = $906f7c99ef13dbef$var$directiveOrder.indexOf(a.type) === -1 ? $906f7c99ef13dbef$var$DEFAULT : a.type;
    let typeB = $906f7c99ef13dbef$var$directiveOrder.indexOf(b.type) === -1 ? $906f7c99ef13dbef$var$DEFAULT : b.type;
    return $906f7c99ef13dbef$var$directiveOrder.indexOf(typeA) - $906f7c99ef13dbef$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $906f7c99ef13dbef$var$tickStack = [];
var $906f7c99ef13dbef$var$isHolding = false;
function $906f7c99ef13dbef$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $906f7c99ef13dbef$var$isHolding || setTimeout(()=>{
            $906f7c99ef13dbef$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $906f7c99ef13dbef$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $906f7c99ef13dbef$var$releaseNextTicks() {
    $906f7c99ef13dbef$var$isHolding = false;
    while($906f7c99ef13dbef$var$tickStack.length)$906f7c99ef13dbef$var$tickStack.shift()();
}
function $906f7c99ef13dbef$var$holdNextTicks() {
    $906f7c99ef13dbef$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $906f7c99ef13dbef$var$setClasses(el, value) {
    if (Array.isArray(value)) return $906f7c99ef13dbef$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $906f7c99ef13dbef$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $906f7c99ef13dbef$var$setClasses(el, value());
    return $906f7c99ef13dbef$var$setClassesFromString(el, value);
}
function $906f7c99ef13dbef$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $906f7c99ef13dbef$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $906f7c99ef13dbef$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $906f7c99ef13dbef$var$setStylesFromObject(el, value);
    return $906f7c99ef13dbef$var$setStylesFromString(el, value);
}
function $906f7c99ef13dbef$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $906f7c99ef13dbef$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $906f7c99ef13dbef$var$setStyles(el, previousStyles);
    };
}
function $906f7c99ef13dbef$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $906f7c99ef13dbef$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $906f7c99ef13dbef$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$906f7c99ef13dbef$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $906f7c99ef13dbef$var$registerTransitionsFromHelper(el, modifiers, value);
    else $906f7c99ef13dbef$var$registerTransitionsFromClassString(el, expression, value);
});
function $906f7c99ef13dbef$var$registerTransitionsFromClassString(el, classString, stage) {
    $906f7c99ef13dbef$var$registerTransitionObject(el, $906f7c99ef13dbef$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $906f7c99ef13dbef$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $906f7c99ef13dbef$var$registerTransitionObject(el, $906f7c99ef13dbef$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $906f7c99ef13dbef$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $906f7c99ef13dbef$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $906f7c99ef13dbef$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $906f7c99ef13dbef$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $906f7c99ef13dbef$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $906f7c99ef13dbef$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $906f7c99ef13dbef$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $906f7c99ef13dbef$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $906f7c99ef13dbef$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $906f7c99ef13dbef$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $906f7c99ef13dbef$var$closestHide(parent);
}
function $906f7c99ef13dbef$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $906f7c99ef13dbef$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $906f7c99ef13dbef$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $906f7c99ef13dbef$var$once(()=>{
        $906f7c99ef13dbef$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $906f7c99ef13dbef$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $906f7c99ef13dbef$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $906f7c99ef13dbef$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $906f7c99ef13dbef$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $906f7c99ef13dbef$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $906f7c99ef13dbef$var$mutateDom(()=>{
                stages.end();
            });
            $906f7c99ef13dbef$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $906f7c99ef13dbef$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $906f7c99ef13dbef$var$isCloning = false;
function $906f7c99ef13dbef$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$906f7c99ef13dbef$var$isCloning ? fallback(...args) : callback(...args);
}
function $906f7c99ef13dbef$var$onlyDuringClone(callback) {
    return (...args)=>$906f7c99ef13dbef$var$isCloning && callback(...args);
}
var $906f7c99ef13dbef$var$interceptors = [];
function $906f7c99ef13dbef$var$interceptClone(callback) {
    $906f7c99ef13dbef$var$interceptors.push(callback);
}
function $906f7c99ef13dbef$var$cloneNode(from, to) {
    $906f7c99ef13dbef$var$interceptors.forEach((i)=>i(from, to));
    $906f7c99ef13dbef$var$isCloning = true;
    $906f7c99ef13dbef$var$dontRegisterReactiveSideEffects(()=>{
        $906f7c99ef13dbef$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $906f7c99ef13dbef$var$isCloning = false;
}
var $906f7c99ef13dbef$var$isCloningLegacy = false;
function $906f7c99ef13dbef$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $906f7c99ef13dbef$var$isCloning = true;
    $906f7c99ef13dbef$var$isCloningLegacy = true;
    $906f7c99ef13dbef$var$dontRegisterReactiveSideEffects(()=>{
        $906f7c99ef13dbef$var$cloneTree(newEl);
    });
    $906f7c99ef13dbef$var$isCloning = false;
    $906f7c99ef13dbef$var$isCloningLegacy = false;
}
function $906f7c99ef13dbef$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $906f7c99ef13dbef$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $906f7c99ef13dbef$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $906f7c99ef13dbef$var$initTree(el, shallowWalker);
}
function $906f7c99ef13dbef$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $906f7c99ef13dbef$var$effect;
    $906f7c99ef13dbef$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $906f7c99ef13dbef$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $906f7c99ef13dbef$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $906f7c99ef13dbef$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $906f7c99ef13dbef$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $906f7c99ef13dbef$var$camelCase(name) : name;
    switch(name){
        case "value":
            $906f7c99ef13dbef$var$bindInputValue(el, value);
            break;
        case "style":
            $906f7c99ef13dbef$var$bindStyles(el, value);
            break;
        case "class":
            $906f7c99ef13dbef$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $906f7c99ef13dbef$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $906f7c99ef13dbef$var$bindAttribute(el, name, value);
            break;
    }
}
function $906f7c99ef13dbef$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $906f7c99ef13dbef$var$safeParseBoolean(el.value) === value;
            else el.checked = $906f7c99ef13dbef$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$906f7c99ef13dbef$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $906f7c99ef13dbef$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $906f7c99ef13dbef$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $906f7c99ef13dbef$var$setClasses(el, value);
}
function $906f7c99ef13dbef$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $906f7c99ef13dbef$var$setStyles(el, value);
}
function $906f7c99ef13dbef$var$bindAttributeAndProperty(el, name, value) {
    $906f7c99ef13dbef$var$bindAttribute(el, name, value);
    $906f7c99ef13dbef$var$setPropertyIfChanged(el, name, value);
}
function $906f7c99ef13dbef$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $906f7c99ef13dbef$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($906f7c99ef13dbef$var$isBooleanAttr(name)) value = name;
        $906f7c99ef13dbef$var$setIfChanged(el, name, value);
    }
}
function $906f7c99ef13dbef$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $906f7c99ef13dbef$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $906f7c99ef13dbef$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $906f7c99ef13dbef$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $906f7c99ef13dbef$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $906f7c99ef13dbef$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $906f7c99ef13dbef$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $906f7c99ef13dbef$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $906f7c99ef13dbef$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $906f7c99ef13dbef$var$getAttributeBinding(el, name, fallback);
}
function $906f7c99ef13dbef$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $906f7c99ef13dbef$var$dontAutoEvaluateFunctions(()=>{
            return $906f7c99ef13dbef$var$evaluate(el, binding.expression);
        });
    }
    return $906f7c99ef13dbef$var$getAttributeBinding(el, name, fallback);
}
function $906f7c99ef13dbef$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($906f7c99ef13dbef$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $906f7c99ef13dbef$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $906f7c99ef13dbef$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $906f7c99ef13dbef$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $906f7c99ef13dbef$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($906f7c99ef13dbef$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($906f7c99ef13dbef$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($906f7c99ef13dbef$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $906f7c99ef13dbef$var$release(reference);
    };
}
function $906f7c99ef13dbef$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $906f7c99ef13dbef$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($906f7c99ef13dbef$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $906f7c99ef13dbef$var$stores = {};
var $906f7c99ef13dbef$var$isReactive = false;
function $906f7c99ef13dbef$var$store(name, value) {
    if (!$906f7c99ef13dbef$var$isReactive) {
        $906f7c99ef13dbef$var$stores = $906f7c99ef13dbef$var$reactive($906f7c99ef13dbef$var$stores);
        $906f7c99ef13dbef$var$isReactive = true;
    }
    if (value === void 0) return $906f7c99ef13dbef$var$stores[name];
    $906f7c99ef13dbef$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $906f7c99ef13dbef$var$stores[name].init();
    $906f7c99ef13dbef$var$initInterceptors2($906f7c99ef13dbef$var$stores[name]);
}
function $906f7c99ef13dbef$var$getStores() {
    return $906f7c99ef13dbef$var$stores;
}
// packages/alpinejs/src/binds.js
var $906f7c99ef13dbef$var$binds = {};
function $906f7c99ef13dbef$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $906f7c99ef13dbef$var$applyBindingsObject(name, getBindings());
    else $906f7c99ef13dbef$var$binds[name] = getBindings;
    return ()=>{};
}
function $906f7c99ef13dbef$var$injectBindingProviders(obj) {
    Object.entries($906f7c99ef13dbef$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $906f7c99ef13dbef$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $906f7c99ef13dbef$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $906f7c99ef13dbef$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $906f7c99ef13dbef$var$datas = {};
function $906f7c99ef13dbef$var$data(name, callback) {
    $906f7c99ef13dbef$var$datas[name] = callback;
}
function $906f7c99ef13dbef$var$injectDataProviders(obj, context) {
    Object.entries($906f7c99ef13dbef$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $906f7c99ef13dbef$var$Alpine = {
    get reactive () {
        return $906f7c99ef13dbef$var$reactive;
    },
    get release () {
        return $906f7c99ef13dbef$var$release;
    },
    get effect () {
        return $906f7c99ef13dbef$var$effect;
    },
    get raw () {
        return $906f7c99ef13dbef$var$raw;
    },
    version: "3.13.7",
    flushAndStopDeferringMutations: $906f7c99ef13dbef$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $906f7c99ef13dbef$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $906f7c99ef13dbef$var$disableEffectScheduling,
    startObservingMutations: $906f7c99ef13dbef$var$startObservingMutations,
    stopObservingMutations: $906f7c99ef13dbef$var$stopObservingMutations,
    setReactivityEngine: $906f7c99ef13dbef$var$setReactivityEngine,
    onAttributeRemoved: $906f7c99ef13dbef$var$onAttributeRemoved,
    onAttributesAdded: $906f7c99ef13dbef$var$onAttributesAdded,
    closestDataStack: $906f7c99ef13dbef$var$closestDataStack,
    skipDuringClone: $906f7c99ef13dbef$var$skipDuringClone,
    onlyDuringClone: $906f7c99ef13dbef$var$onlyDuringClone,
    addRootSelector: $906f7c99ef13dbef$var$addRootSelector,
    addInitSelector: $906f7c99ef13dbef$var$addInitSelector,
    interceptClone: $906f7c99ef13dbef$var$interceptClone,
    addScopeToNode: $906f7c99ef13dbef$var$addScopeToNode,
    deferMutations: $906f7c99ef13dbef$var$deferMutations,
    mapAttributes: $906f7c99ef13dbef$var$mapAttributes,
    evaluateLater: $906f7c99ef13dbef$var$evaluateLater,
    interceptInit: $906f7c99ef13dbef$var$interceptInit,
    setEvaluator: $906f7c99ef13dbef$var$setEvaluator,
    mergeProxies: $906f7c99ef13dbef$var$mergeProxies,
    extractProp: $906f7c99ef13dbef$var$extractProp,
    findClosest: $906f7c99ef13dbef$var$findClosest,
    onElRemoved: $906f7c99ef13dbef$var$onElRemoved,
    closestRoot: $906f7c99ef13dbef$var$closestRoot,
    destroyTree: $906f7c99ef13dbef$var$destroyTree,
    interceptor: $906f7c99ef13dbef$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $906f7c99ef13dbef$var$transition,
    setStyles: // INTERNAL
    $906f7c99ef13dbef$var$setStyles,
    mutateDom: // INTERNAL
    $906f7c99ef13dbef$var$mutateDom,
    directive: $906f7c99ef13dbef$var$directive,
    entangle: $906f7c99ef13dbef$var$entangle,
    throttle: $906f7c99ef13dbef$var$throttle,
    debounce: $906f7c99ef13dbef$var$debounce,
    evaluate: $906f7c99ef13dbef$var$evaluate,
    initTree: $906f7c99ef13dbef$var$initTree,
    nextTick: $906f7c99ef13dbef$var$nextTick,
    prefixed: $906f7c99ef13dbef$var$prefix,
    prefix: $906f7c99ef13dbef$var$setPrefix,
    plugin: $906f7c99ef13dbef$var$plugin,
    magic: $906f7c99ef13dbef$var$magic,
    store: $906f7c99ef13dbef$var$store,
    start: $906f7c99ef13dbef$var$start,
    clone: $906f7c99ef13dbef$var$clone,
    cloneNode: // INTERNAL
    $906f7c99ef13dbef$var$cloneNode,
    // INTERNAL
    bound: $906f7c99ef13dbef$var$getBinding,
    $data: $906f7c99ef13dbef$var$scope,
    watch: $906f7c99ef13dbef$var$watch,
    walk: $906f7c99ef13dbef$var$walk,
    data: $906f7c99ef13dbef$var$data,
    bind: $906f7c99ef13dbef$var$bind2
};
var $906f7c99ef13dbef$var$alpine_default = $906f7c99ef13dbef$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $906f7c99ef13dbef$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $906f7c99ef13dbef$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $906f7c99ef13dbef$var$isBooleanAttr2 = /* @__PURE__ */ $906f7c99ef13dbef$var$makeMap($906f7c99ef13dbef$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $906f7c99ef13dbef$var$EMPTY_OBJ = Object.freeze({});
var $906f7c99ef13dbef$var$EMPTY_ARR = Object.freeze([]);
var $906f7c99ef13dbef$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $906f7c99ef13dbef$var$hasOwn = (val, key)=>$906f7c99ef13dbef$var$hasOwnProperty.call(val, key);
var $906f7c99ef13dbef$var$isArray = Array.isArray;
var $906f7c99ef13dbef$var$isMap = (val)=>$906f7c99ef13dbef$var$toTypeString(val) === "[object Map]";
var $906f7c99ef13dbef$var$isString = (val)=>typeof val === "string";
var $906f7c99ef13dbef$var$isSymbol = (val)=>typeof val === "symbol";
var $906f7c99ef13dbef$var$isObject = (val)=>val !== null && typeof val === "object";
var $906f7c99ef13dbef$var$objectToString = Object.prototype.toString;
var $906f7c99ef13dbef$var$toTypeString = (value)=>$906f7c99ef13dbef$var$objectToString.call(value);
var $906f7c99ef13dbef$var$toRawType = (value)=>{
    return $906f7c99ef13dbef$var$toTypeString(value).slice(8, -1);
};
var $906f7c99ef13dbef$var$isIntegerKey = (key)=>$906f7c99ef13dbef$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $906f7c99ef13dbef$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $906f7c99ef13dbef$var$camelizeRE = /-(\w)/g;
var $906f7c99ef13dbef$var$camelize = $906f7c99ef13dbef$var$cacheStringFunction((str)=>{
    return str.replace($906f7c99ef13dbef$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $906f7c99ef13dbef$var$hyphenateRE = /\B([A-Z])/g;
var $906f7c99ef13dbef$var$hyphenate = $906f7c99ef13dbef$var$cacheStringFunction((str)=>str.replace($906f7c99ef13dbef$var$hyphenateRE, "-$1").toLowerCase());
var $906f7c99ef13dbef$var$capitalize = $906f7c99ef13dbef$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $906f7c99ef13dbef$var$toHandlerKey = $906f7c99ef13dbef$var$cacheStringFunction((str)=>str ? `on${$906f7c99ef13dbef$var$capitalize(str)}` : ``);
var $906f7c99ef13dbef$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $906f7c99ef13dbef$var$targetMap = /* @__PURE__ */ new WeakMap();
var $906f7c99ef13dbef$var$effectStack = [];
var $906f7c99ef13dbef$var$activeEffect;
var $906f7c99ef13dbef$var$ITERATE_KEY = Symbol("iterate");
var $906f7c99ef13dbef$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $906f7c99ef13dbef$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $906f7c99ef13dbef$var$effect2(fn, options = $906f7c99ef13dbef$var$EMPTY_OBJ) {
    if ($906f7c99ef13dbef$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $906f7c99ef13dbef$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $906f7c99ef13dbef$var$stop(effect3) {
    if (effect3.active) {
        $906f7c99ef13dbef$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $906f7c99ef13dbef$var$uid = 0;
function $906f7c99ef13dbef$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$906f7c99ef13dbef$var$effectStack.includes(effect3)) {
            $906f7c99ef13dbef$var$cleanup(effect3);
            try {
                $906f7c99ef13dbef$var$enableTracking();
                $906f7c99ef13dbef$var$effectStack.push(effect3);
                $906f7c99ef13dbef$var$activeEffect = effect3;
                return fn();
            } finally{
                $906f7c99ef13dbef$var$effectStack.pop();
                $906f7c99ef13dbef$var$resetTracking();
                $906f7c99ef13dbef$var$activeEffect = $906f7c99ef13dbef$var$effectStack[$906f7c99ef13dbef$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $906f7c99ef13dbef$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $906f7c99ef13dbef$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $906f7c99ef13dbef$var$shouldTrack = true;
var $906f7c99ef13dbef$var$trackStack = [];
function $906f7c99ef13dbef$var$pauseTracking() {
    $906f7c99ef13dbef$var$trackStack.push($906f7c99ef13dbef$var$shouldTrack);
    $906f7c99ef13dbef$var$shouldTrack = false;
}
function $906f7c99ef13dbef$var$enableTracking() {
    $906f7c99ef13dbef$var$trackStack.push($906f7c99ef13dbef$var$shouldTrack);
    $906f7c99ef13dbef$var$shouldTrack = true;
}
function $906f7c99ef13dbef$var$resetTracking() {
    const last = $906f7c99ef13dbef$var$trackStack.pop();
    $906f7c99ef13dbef$var$shouldTrack = last === void 0 ? true : last;
}
function $906f7c99ef13dbef$var$track(target, type, key) {
    if (!$906f7c99ef13dbef$var$shouldTrack || $906f7c99ef13dbef$var$activeEffect === void 0) return;
    let depsMap = $906f7c99ef13dbef$var$targetMap.get(target);
    if (!depsMap) $906f7c99ef13dbef$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($906f7c99ef13dbef$var$activeEffect)) {
        dep.add($906f7c99ef13dbef$var$activeEffect);
        $906f7c99ef13dbef$var$activeEffect.deps.push(dep);
        if ($906f7c99ef13dbef$var$activeEffect.options.onTrack) $906f7c99ef13dbef$var$activeEffect.options.onTrack({
            effect: $906f7c99ef13dbef$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $906f7c99ef13dbef$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $906f7c99ef13dbef$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $906f7c99ef13dbef$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $906f7c99ef13dbef$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$906f7c99ef13dbef$var$isArray(target)) {
                    add2(depsMap.get($906f7c99ef13dbef$var$ITERATE_KEY));
                    if ($906f7c99ef13dbef$var$isMap(target)) add2(depsMap.get($906f7c99ef13dbef$var$MAP_KEY_ITERATE_KEY));
                } else if ($906f7c99ef13dbef$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$906f7c99ef13dbef$var$isArray(target)) {
                    add2(depsMap.get($906f7c99ef13dbef$var$ITERATE_KEY));
                    if ($906f7c99ef13dbef$var$isMap(target)) add2(depsMap.get($906f7c99ef13dbef$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($906f7c99ef13dbef$var$isMap(target)) add2(depsMap.get($906f7c99ef13dbef$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $906f7c99ef13dbef$var$isNonTrackableKeys = /* @__PURE__ */ $906f7c99ef13dbef$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $906f7c99ef13dbef$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($906f7c99ef13dbef$var$isSymbol));
var $906f7c99ef13dbef$var$get2 = /* @__PURE__ */ $906f7c99ef13dbef$var$createGetter();
var $906f7c99ef13dbef$var$readonlyGet = /* @__PURE__ */ $906f7c99ef13dbef$var$createGetter(true);
var $906f7c99ef13dbef$var$arrayInstrumentations = /* @__PURE__ */ $906f7c99ef13dbef$var$createArrayInstrumentations();
function $906f7c99ef13dbef$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $906f7c99ef13dbef$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$906f7c99ef13dbef$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($906f7c99ef13dbef$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $906f7c99ef13dbef$var$pauseTracking();
            const res = $906f7c99ef13dbef$var$toRaw(this)[key].apply(this, args);
            $906f7c99ef13dbef$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $906f7c99ef13dbef$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $906f7c99ef13dbef$var$shallowReadonlyMap : $906f7c99ef13dbef$var$readonlyMap : shallow ? $906f7c99ef13dbef$var$shallowReactiveMap : $906f7c99ef13dbef$var$reactiveMap).get(target)) return target;
        const targetIsArray = $906f7c99ef13dbef$var$isArray(target);
        if (!isReadonly && targetIsArray && $906f7c99ef13dbef$var$hasOwn($906f7c99ef13dbef$var$arrayInstrumentations, key)) return Reflect.get($906f7c99ef13dbef$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($906f7c99ef13dbef$var$isSymbol(key) ? $906f7c99ef13dbef$var$builtInSymbols.has(key) : $906f7c99ef13dbef$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $906f7c99ef13dbef$var$track(target, "get", key);
        if (shallow) return res;
        if ($906f7c99ef13dbef$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$906f7c99ef13dbef$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($906f7c99ef13dbef$var$isObject(res)) return isReadonly ? $906f7c99ef13dbef$var$readonly(res) : $906f7c99ef13dbef$var$reactive2(res);
        return res;
    };
}
var $906f7c99ef13dbef$var$set2 = /* @__PURE__ */ $906f7c99ef13dbef$var$createSetter();
function $906f7c99ef13dbef$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $906f7c99ef13dbef$var$toRaw(value);
            oldValue = $906f7c99ef13dbef$var$toRaw(oldValue);
            if (!$906f7c99ef13dbef$var$isArray(target) && $906f7c99ef13dbef$var$isRef(oldValue) && !$906f7c99ef13dbef$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $906f7c99ef13dbef$var$isArray(target) && $906f7c99ef13dbef$var$isIntegerKey(key) ? Number(key) < target.length : $906f7c99ef13dbef$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $906f7c99ef13dbef$var$toRaw(receiver)) {
            if (!hadKey) $906f7c99ef13dbef$var$trigger(target, "add", key, value);
            else if ($906f7c99ef13dbef$var$hasChanged(value, oldValue)) $906f7c99ef13dbef$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $906f7c99ef13dbef$var$deleteProperty(target, key) {
    const hadKey = $906f7c99ef13dbef$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $906f7c99ef13dbef$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $906f7c99ef13dbef$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$906f7c99ef13dbef$var$isSymbol(key) || !$906f7c99ef13dbef$var$builtInSymbols.has(key)) $906f7c99ef13dbef$var$track(target, "has", key);
    return result;
}
function $906f7c99ef13dbef$var$ownKeys(target) {
    $906f7c99ef13dbef$var$track(target, "iterate", $906f7c99ef13dbef$var$isArray(target) ? "length" : $906f7c99ef13dbef$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $906f7c99ef13dbef$var$mutableHandlers = {
    get: $906f7c99ef13dbef$var$get2,
    set: $906f7c99ef13dbef$var$set2,
    deleteProperty: $906f7c99ef13dbef$var$deleteProperty,
    has: $906f7c99ef13dbef$var$has,
    ownKeys: $906f7c99ef13dbef$var$ownKeys
};
var $906f7c99ef13dbef$var$readonlyHandlers = {
    get: $906f7c99ef13dbef$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $906f7c99ef13dbef$var$toReactive = (value)=>$906f7c99ef13dbef$var$isObject(value) ? $906f7c99ef13dbef$var$reactive2(value) : value;
var $906f7c99ef13dbef$var$toReadonly = (value)=>$906f7c99ef13dbef$var$isObject(value) ? $906f7c99ef13dbef$var$readonly(value) : value;
var $906f7c99ef13dbef$var$toShallow = (value)=>value;
var $906f7c99ef13dbef$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $906f7c99ef13dbef$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $906f7c99ef13dbef$var$toRaw(target);
    const rawKey = $906f7c99ef13dbef$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "get", key);
    !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $906f7c99ef13dbef$var$getProto(rawTarget);
    const wrap = isShallow ? $906f7c99ef13dbef$var$toShallow : isReadonly ? $906f7c99ef13dbef$var$toReadonly : $906f7c99ef13dbef$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $906f7c99ef13dbef$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $906f7c99ef13dbef$var$toRaw(target);
    const rawKey = $906f7c99ef13dbef$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "has", key);
    !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $906f7c99ef13dbef$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $906f7c99ef13dbef$var$track($906f7c99ef13dbef$var$toRaw(target), "iterate", $906f7c99ef13dbef$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $906f7c99ef13dbef$var$add(value) {
    value = $906f7c99ef13dbef$var$toRaw(value);
    const target = $906f7c99ef13dbef$var$toRaw(this);
    const proto = $906f7c99ef13dbef$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $906f7c99ef13dbef$var$trigger(target, "add", value, value);
    }
    return this;
}
function $906f7c99ef13dbef$var$set$1(key, value) {
    value = $906f7c99ef13dbef$var$toRaw(value);
    const target = $906f7c99ef13dbef$var$toRaw(this);
    const { has: has2, get: get3 } = $906f7c99ef13dbef$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $906f7c99ef13dbef$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $906f7c99ef13dbef$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $906f7c99ef13dbef$var$trigger(target, "add", key, value);
    else if ($906f7c99ef13dbef$var$hasChanged(value, oldValue)) $906f7c99ef13dbef$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $906f7c99ef13dbef$var$deleteEntry(key) {
    const target = $906f7c99ef13dbef$var$toRaw(this);
    const { has: has2, get: get3 } = $906f7c99ef13dbef$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $906f7c99ef13dbef$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $906f7c99ef13dbef$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $906f7c99ef13dbef$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $906f7c99ef13dbef$var$clear() {
    const target = $906f7c99ef13dbef$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $906f7c99ef13dbef$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $906f7c99ef13dbef$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $906f7c99ef13dbef$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $906f7c99ef13dbef$var$toRaw(target);
        const wrap = isShallow ? $906f7c99ef13dbef$var$toShallow : isReadonly ? $906f7c99ef13dbef$var$toReadonly : $906f7c99ef13dbef$var$toReactive;
        !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "iterate", $906f7c99ef13dbef$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $906f7c99ef13dbef$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $906f7c99ef13dbef$var$toRaw(target);
        const targetIsMap = $906f7c99ef13dbef$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $906f7c99ef13dbef$var$toShallow : isReadonly ? $906f7c99ef13dbef$var$toReadonly : $906f7c99ef13dbef$var$toReactive;
        !isReadonly && $906f7c99ef13dbef$var$track(rawTarget, "iterate", isKeyOnly ? $906f7c99ef13dbef$var$MAP_KEY_ITERATE_KEY : $906f7c99ef13dbef$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $906f7c99ef13dbef$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$906f7c99ef13dbef$var$capitalize(type)} operation ${key}failed: target is readonly.`, $906f7c99ef13dbef$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $906f7c99ef13dbef$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $906f7c99ef13dbef$var$get$1(this, key);
        },
        get size () {
            return $906f7c99ef13dbef$var$size(this);
        },
        has: $906f7c99ef13dbef$var$has$1,
        add: $906f7c99ef13dbef$var$add,
        set: $906f7c99ef13dbef$var$set$1,
        delete: $906f7c99ef13dbef$var$deleteEntry,
        clear: $906f7c99ef13dbef$var$clear,
        forEach: $906f7c99ef13dbef$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $906f7c99ef13dbef$var$get$1(this, key, false, true);
        },
        get size () {
            return $906f7c99ef13dbef$var$size(this);
        },
        has: $906f7c99ef13dbef$var$has$1,
        add: $906f7c99ef13dbef$var$add,
        set: $906f7c99ef13dbef$var$set$1,
        delete: $906f7c99ef13dbef$var$deleteEntry,
        clear: $906f7c99ef13dbef$var$clear,
        forEach: $906f7c99ef13dbef$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $906f7c99ef13dbef$var$get$1(this, key, true);
        },
        get size () {
            return $906f7c99ef13dbef$var$size(this, true);
        },
        has (key) {
            return $906f7c99ef13dbef$var$has$1.call(this, key, true);
        },
        add: $906f7c99ef13dbef$var$createReadonlyMethod("add"),
        set: $906f7c99ef13dbef$var$createReadonlyMethod("set"),
        delete: $906f7c99ef13dbef$var$createReadonlyMethod("delete"),
        clear: $906f7c99ef13dbef$var$createReadonlyMethod("clear"),
        forEach: $906f7c99ef13dbef$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $906f7c99ef13dbef$var$get$1(this, key, true, true);
        },
        get size () {
            return $906f7c99ef13dbef$var$size(this, true);
        },
        has (key) {
            return $906f7c99ef13dbef$var$has$1.call(this, key, true);
        },
        add: $906f7c99ef13dbef$var$createReadonlyMethod("add"),
        set: $906f7c99ef13dbef$var$createReadonlyMethod("set"),
        delete: $906f7c99ef13dbef$var$createReadonlyMethod("delete"),
        clear: $906f7c99ef13dbef$var$createReadonlyMethod("clear"),
        forEach: $906f7c99ef13dbef$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $906f7c99ef13dbef$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $906f7c99ef13dbef$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $906f7c99ef13dbef$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $906f7c99ef13dbef$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$906f7c99ef13dbef$var$mutableInstrumentations, $906f7c99ef13dbef$var$readonlyInstrumentations, $906f7c99ef13dbef$var$shallowInstrumentations, $906f7c99ef13dbef$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $906f7c99ef13dbef$var$createInstrumentations();
function $906f7c99ef13dbef$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $906f7c99ef13dbef$var$shallowReadonlyInstrumentations : $906f7c99ef13dbef$var$shallowInstrumentations : isReadonly ? $906f7c99ef13dbef$var$readonlyInstrumentations : $906f7c99ef13dbef$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($906f7c99ef13dbef$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $906f7c99ef13dbef$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $906f7c99ef13dbef$var$createInstrumentationGetter(false, false)
};
var $906f7c99ef13dbef$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $906f7c99ef13dbef$var$createInstrumentationGetter(true, false)
};
function $906f7c99ef13dbef$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $906f7c99ef13dbef$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $906f7c99ef13dbef$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $906f7c99ef13dbef$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $906f7c99ef13dbef$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $906f7c99ef13dbef$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $906f7c99ef13dbef$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $906f7c99ef13dbef$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $906f7c99ef13dbef$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $906f7c99ef13dbef$var$targetTypeMap($906f7c99ef13dbef$var$toRawType(value));
}
function $906f7c99ef13dbef$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $906f7c99ef13dbef$var$createReactiveObject(target, false, $906f7c99ef13dbef$var$mutableHandlers, $906f7c99ef13dbef$var$mutableCollectionHandlers, $906f7c99ef13dbef$var$reactiveMap);
}
function $906f7c99ef13dbef$var$readonly(target) {
    return $906f7c99ef13dbef$var$createReactiveObject(target, true, $906f7c99ef13dbef$var$readonlyHandlers, $906f7c99ef13dbef$var$readonlyCollectionHandlers, $906f7c99ef13dbef$var$readonlyMap);
}
function $906f7c99ef13dbef$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$906f7c99ef13dbef$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $906f7c99ef13dbef$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $906f7c99ef13dbef$var$toRaw(observed) {
    return observed && $906f7c99ef13dbef$var$toRaw(observed["__v_raw"]) || observed;
}
function $906f7c99ef13dbef$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$906f7c99ef13dbef$var$magic("nextTick", ()=>$906f7c99ef13dbef$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$906f7c99ef13dbef$var$magic("dispatch", (el)=>$906f7c99ef13dbef$var$dispatch.bind($906f7c99ef13dbef$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$906f7c99ef13dbef$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $906f7c99ef13dbef$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$906f7c99ef13dbef$var$magic("store", $906f7c99ef13dbef$var$getStores);
// packages/alpinejs/src/magics/$data.js
$906f7c99ef13dbef$var$magic("data", (el)=>$906f7c99ef13dbef$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$906f7c99ef13dbef$var$magic("root", (el)=>$906f7c99ef13dbef$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$906f7c99ef13dbef$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $906f7c99ef13dbef$var$mergeProxies($906f7c99ef13dbef$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $906f7c99ef13dbef$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $906f7c99ef13dbef$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $906f7c99ef13dbef$var$globalIdMemo = {};
function $906f7c99ef13dbef$var$findAndIncrementId(name) {
    if (!$906f7c99ef13dbef$var$globalIdMemo[name]) $906f7c99ef13dbef$var$globalIdMemo[name] = 0;
    return ++$906f7c99ef13dbef$var$globalIdMemo[name];
}
function $906f7c99ef13dbef$var$closestIdRoot(el, name) {
    return $906f7c99ef13dbef$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $906f7c99ef13dbef$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $906f7c99ef13dbef$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$906f7c99ef13dbef$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $906f7c99ef13dbef$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $906f7c99ef13dbef$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $906f7c99ef13dbef$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$906f7c99ef13dbef$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $906f7c99ef13dbef$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$906f7c99ef13dbef$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$906f7c99ef13dbef$var$warnMissingPluginMagic("Focus", "focus", "focus");
$906f7c99ef13dbef$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $906f7c99ef13dbef$var$warnMissingPluginMagic(name, magicName, slug) {
    $906f7c99ef13dbef$var$magic(magicName, (el)=>$906f7c99ef13dbef$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$906f7c99ef13dbef$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $906f7c99ef13dbef$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$906f7c99ef13dbef$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $906f7c99ef13dbef$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $906f7c99ef13dbef$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $906f7c99ef13dbef$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $906f7c99ef13dbef$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $906f7c99ef13dbef$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $906f7c99ef13dbef$var$getTarget(expression);
        $906f7c99ef13dbef$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $906f7c99ef13dbef$var$teleportContainerDuringClone = document.createElement("div");
function $906f7c99ef13dbef$var$getTarget(expression) {
    let target = $906f7c99ef13dbef$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $906f7c99ef13dbef$var$teleportContainerDuringClone;
    })();
    if (!target) $906f7c99ef13dbef$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $906f7c99ef13dbef$var$handler = ()=>{};
$906f7c99ef13dbef$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$906f7c99ef13dbef$var$directive("ignore", $906f7c99ef13dbef$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$906f7c99ef13dbef$var$directive("effect", $906f7c99ef13dbef$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($906f7c99ef13dbef$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $906f7c99ef13dbef$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $906f7c99ef13dbef$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $906f7c99ef13dbef$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $906f7c99ef13dbef$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $906f7c99ef13dbef$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $906f7c99ef13dbef$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $906f7c99ef13dbef$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($906f7c99ef13dbef$var$isKeyEvent(event)) {
            if ($906f7c99ef13dbef$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $906f7c99ef13dbef$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $906f7c99ef13dbef$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $906f7c99ef13dbef$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $906f7c99ef13dbef$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $906f7c99ef13dbef$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $906f7c99ef13dbef$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $906f7c99ef13dbef$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $906f7c99ef13dbef$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $906f7c99ef13dbef$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($906f7c99ef13dbef$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $906f7c99ef13dbef$var$keyToModifiers(key) {
    if (!key) return [];
    key = $906f7c99ef13dbef$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$906f7c99ef13dbef$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $906f7c99ef13dbef$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $906f7c99ef13dbef$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $906f7c99ef13dbef$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $906f7c99ef13dbef$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($906f7c99ef13dbef$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $906f7c99ef13dbef$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $906f7c99ef13dbef$var$isCloning ? ()=>{} : $906f7c99ef13dbef$var$on(el, event, modifiers, (e)=>{
        setValue($906f7c99ef13dbef$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $906f7c99ef13dbef$var$on(el.form, "reset", [], (e)=>{
            $906f7c99ef13dbef$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $906f7c99ef13dbef$var$mutateDom(()=>$906f7c99ef13dbef$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $906f7c99ef13dbef$var$getInputValue(el, modifiers, event, currentValue) {
    return $906f7c99ef13dbef$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $906f7c99ef13dbef$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $906f7c99ef13dbef$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$906f7c99ef13dbef$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $906f7c99ef13dbef$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $906f7c99ef13dbef$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $906f7c99ef13dbef$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $906f7c99ef13dbef$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $906f7c99ef13dbef$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $906f7c99ef13dbef$var$isNumeric2(number) ? number : rawValue;
}
function $906f7c99ef13dbef$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $906f7c99ef13dbef$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $906f7c99ef13dbef$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$906f7c99ef13dbef$var$directive("cloak", (el)=>queueMicrotask(()=>$906f7c99ef13dbef$var$mutateDom(()=>el.removeAttribute($906f7c99ef13dbef$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$906f7c99ef13dbef$var$addInitSelector(()=>`[${$906f7c99ef13dbef$var$prefix("init")}]`);
$906f7c99ef13dbef$var$directive("init", $906f7c99ef13dbef$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$906f7c99ef13dbef$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $906f7c99ef13dbef$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$906f7c99ef13dbef$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $906f7c99ef13dbef$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $906f7c99ef13dbef$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$906f7c99ef13dbef$var$mapAttributes($906f7c99ef13dbef$var$startingWith(":", $906f7c99ef13dbef$var$into($906f7c99ef13dbef$var$prefix("bind:"))));
var $906f7c99ef13dbef$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $906f7c99ef13dbef$var$injectBindingProviders(bindingProviders);
        let getBindings = $906f7c99ef13dbef$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $906f7c99ef13dbef$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $906f7c99ef13dbef$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $906f7c99ef13dbef$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $906f7c99ef13dbef$var$mutateDom(()=>$906f7c99ef13dbef$var$bind(el, value, result, modifiers));
        }));
};
$906f7c99ef13dbef$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$906f7c99ef13dbef$var$directive("bind", $906f7c99ef13dbef$var$handler2);
function $906f7c99ef13dbef$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$906f7c99ef13dbef$var$addRootSelector(()=>`[${$906f7c99ef13dbef$var$prefix("data")}]`);
$906f7c99ef13dbef$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($906f7c99ef13dbef$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $906f7c99ef13dbef$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $906f7c99ef13dbef$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $906f7c99ef13dbef$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $906f7c99ef13dbef$var$injectMagics(data2, el);
    let reactiveData = $906f7c99ef13dbef$var$reactive(data2);
    $906f7c99ef13dbef$var$initInterceptors2(reactiveData);
    let undo = $906f7c99ef13dbef$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $906f7c99ef13dbef$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $906f7c99ef13dbef$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$906f7c99ef13dbef$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $906f7c99ef13dbef$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$906f7c99ef13dbef$var$isCloning) return false;
    if ($906f7c99ef13dbef$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$906f7c99ef13dbef$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $906f7c99ef13dbef$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $906f7c99ef13dbef$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $906f7c99ef13dbef$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $906f7c99ef13dbef$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$906f7c99ef13dbef$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $906f7c99ef13dbef$var$parseForExpression(expression);
    let evaluateItems = $906f7c99ef13dbef$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $906f7c99ef13dbef$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$906f7c99ef13dbef$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $906f7c99ef13dbef$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($906f7c99ef13dbef$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $906f7c99ef13dbef$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $906f7c99ef13dbef$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $906f7c99ef13dbef$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $906f7c99ef13dbef$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($906f7c99ef13dbef$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $906f7c99ef13dbef$var$mutateDom(()=>{
                if (!elForSpot) $906f7c99ef13dbef$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $906f7c99ef13dbef$var$reactive(scope2);
            $906f7c99ef13dbef$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $906f7c99ef13dbef$var$mutateDom(()=>{
                lastEl.after(clone2);
                $906f7c99ef13dbef$var$skipDuringClone(()=>$906f7c99ef13dbef$var$initTree(clone2))();
            });
            if (typeof key === "object") $906f7c99ef13dbef$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $906f7c99ef13dbef$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $906f7c99ef13dbef$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $906f7c99ef13dbef$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $906f7c99ef13dbef$var$handler3() {}
$906f7c99ef13dbef$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $906f7c99ef13dbef$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$906f7c99ef13dbef$var$directive("ref", $906f7c99ef13dbef$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$906f7c99ef13dbef$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $906f7c99ef13dbef$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $906f7c99ef13dbef$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $906f7c99ef13dbef$var$addScopeToNode(clone2, {}, el);
        $906f7c99ef13dbef$var$mutateDom(()=>{
            el.after(clone2);
            $906f7c99ef13dbef$var$skipDuringClone(()=>$906f7c99ef13dbef$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $906f7c99ef13dbef$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($906f7c99ef13dbef$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$906f7c99ef13dbef$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$906f7c99ef13dbef$var$setIdRoot(el, name));
});
$906f7c99ef13dbef$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$906f7c99ef13dbef$var$mapAttributes($906f7c99ef13dbef$var$startingWith("@", $906f7c99ef13dbef$var$into($906f7c99ef13dbef$var$prefix("on:"))));
$906f7c99ef13dbef$var$directive("on", $906f7c99ef13dbef$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $906f7c99ef13dbef$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $906f7c99ef13dbef$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$906f7c99ef13dbef$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$906f7c99ef13dbef$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$906f7c99ef13dbef$var$warnMissingPluginDirective("Focus", "trap", "focus");
$906f7c99ef13dbef$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $906f7c99ef13dbef$var$warnMissingPluginDirective(name, directiveName, slug) {
    $906f7c99ef13dbef$var$directive(directiveName, (el)=>$906f7c99ef13dbef$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$906f7c99ef13dbef$var$alpine_default.setEvaluator($906f7c99ef13dbef$var$normalEvaluator);
$906f7c99ef13dbef$var$alpine_default.setReactivityEngine({
    reactive: $906f7c99ef13dbef$var$reactive2,
    effect: $906f7c99ef13dbef$var$effect2,
    release: $906f7c99ef13dbef$var$stop,
    raw: $906f7c99ef13dbef$var$toRaw
});
var $906f7c99ef13dbef$export$b7ee041e4ad2afec = $906f7c99ef13dbef$var$alpine_default;
// packages/alpinejs/builds/module.js
var $906f7c99ef13dbef$export$2e2bcd8739ae039 = $906f7c99ef13dbef$export$b7ee041e4ad2afec;


window.Alpine = (0, $906f7c99ef13dbef$export$2e2bcd8739ae039);
(0, $906f7c99ef13dbef$export$2e2bcd8739ae039).start();


//# sourceMappingURL=index.0018dea3.js.map
